export default __webpack_public_path__ + "static/media/user_poap_05.5b91ff7d.svg";